import { IContractVersion } from "./Contract";

export interface IGymListing {
  id: string;
  licenseGymName: string;
  endpoint: string;
  webEndpoint: string;
  isSuspended: boolean;
  lastMinDealEnabled: boolean;
  businessName: string;
  description: string;
  lat: number;
  long: number;
  country: string;
  city: string;
  street: string;
  streetNumber: string;
  postcode: string;
  facilityOffers: string;
  status: GymListingStatusEnum;
  gymListingContracts: IGymListingContract[];
  imagePaths: string[];
  createdAt: string;
  updatedAt: string;
}

export enum GymListingStatusEnum {
  Declined = "Declined",
  Approved = "Approved",
  UnderReview = "UnderReview",
}

export interface IGymListingContract {
  id: string;
  assignedAt: Date | null;
  gymListingId: string;
  contractVersionId: string;
  contractVersion: IContractVersion;
}
